import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const GetTicketsRequest = (close, activeStage) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Tickets/GetTickets`,
	params: { close, activeStage }
});

export const GetTicketRequest = (ticketId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Tickets/GetTicket`,
	params: { ticketId }
});

export const GetTeamsByTypeRequest = (typeId, active) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Tickets/GetTeamsByType`,
	params: { typeId, active }
});

export const GetTypesRequest = (activityId, active) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Tickets/GetTypes`,
	params: { activityId, active }
});

export const GetActivitiesRequest = (active) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Tickets/GetActivities`,
	params: { active }
});

export const AddTicketRequest = (ticket) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}Tickets/AddTicket`,
	data: ticket
});

export const AddCommentRequest = (ticketId, userId, comment) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}Tickets/AddComment`,
	data: { ticketId, userId, comment }
});

export const AddAttachedFileRequest = (ticketId, fileName, userId) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}Tickets/AddAttachFile`,
	data: { ticketId, fileName, userId }
});

export const DeleteTicketRequest = (ticketId) => AxiosRequest({
	method: 'DELETE',
	url: `${config.API_URL}Tickets/DeleteTicket`,
	params: { ticketId }
});

export const DeleteAttachFileRequest = (ticketFileId, userId) => AxiosRequest({
	method: 'DELETE',
	url: `${config.API_URL}Tickets/DeleteAttachFile`,
	params: { ticketFileId, userId }
});

export const GetStagesRequest = (currentStageId, active) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Tickets/GetNextStages`,
	params: { currentStageId, active }
});

export const EditTicketRequest = (ticket) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}Tickets/EditTicket`,
	data: ticket
});
